"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ToggleState = _interopRequireDefault(require("./utils/ToggleState"));

var _TriggerResize = _interopRequireDefault(require("./utils/TriggerResize"));

var _excluded = ["appLogo", "appName", "tag", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import ToggleFullscreen from '../utils/ToggleFullscreen';

/**
 * The Topbar component is used as a container for an application header.
 * Mostly used paired with the Sibebar component which contains the application navigation.
 */
var Topbar = function Topbar(_ref) {
  var AppLogo = _ref.appLogo,
      appName = _ref.appName,
      Tag = _ref.tag,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = (0, _clsx.default)('uk-topbar', className);
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-topbar__title"
  }, /*#__PURE__*/_react.default.createElement(_ToggleState.default, {
    state: "uk-aside-toggled"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "hide-for-large",
    displayAsLink: true,
    color: "white",
    icon: "bars",
    "aria-controls": "topBarContent",
    "aria-label": "Toggle navigation"
  })), /*#__PURE__*/_react.default.createElement(AppLogo, null)), /*#__PURE__*/_react.default.createElement(_TriggerResize.default, null, /*#__PURE__*/_react.default.createElement(_ToggleState.default, {
    state: "uk-aside-collapsed"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "show-for-large",
    displayAsLink: true,
    color: "white",
    icon: "bars",
    "aria-controls": "topBarContent",
    "aria-label": "Toggle navigation"
  }))), children);
};

Topbar.propTypes = {
  /**
   * HTML tag used as root tag of the Topbar
   */
  tag: _propTypes.default.string,

  /**
   * Application branding
   */
  appLogo: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]).isRequired
};
Topbar.defaultProps = {
  tag: 'header'
};
var _default = Topbar;
exports.default = _default;